export class DimensionField {
    constructor(public Id: number, public Name: string) {
    }
}
